export default {
  init() {
    // JavaScript to be fired on the about us page
  },
  finalize() {
    $('.about-nav .current-section').click(function() {
      $(this).toggleClass('open').next('ul').slideToggle(200);
    });

    $('.about-nav ul a').click(function() {
      $('.about-nav ul').hide();
      $('.about-nav .current-section').removeClass('open');
      $('.about-nav .current-section').text($(this).text());
    });

    $(window).load(function() {
      $('.modal').removeAttr('style');
    });

    $('.about-intro a').click(function(e) {
      e.preventDefault();
      $('.modal').addClass('open');
    });

    $('.modal .x, .modal').click(function() {
      $('.modal').removeClass('open');
      var thesrc = $('.modal iframe').attr('src');
      $('.modal iframe').attr('src', '').attr('src', thesrc);
    });

    $('.modal .modal-inner *').click(function(e) {
      e.stopPropagation();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/about.js